import React from 'react';
import AppContext from './context';
const useApp = () => React.useContext(AppContext);
export default useApp;
